'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeErrorBarsIcon = function TraceTypeErrorBarsIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('circle', { cx: '23', cy: '31', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M23 23v16m4 0h-8m8-16h-8', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('circle', { cx: '11', cy: '23', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M11 11v24m4 0H7m8-24H7', strokeMiterlimit: '10', strokeWidth: '2' }),
        _react2.default.createElement('circle', { cx: '35', cy: '21', r: '3', fill: '#1d9bfb' }),
        _react2.default.createElement('path', { fill: 'none', stroke: '#1d9bfb', d: 'M35 9v24m4 0h-8m8-24h-8', strokeMiterlimit: '10', strokeWidth: '2' })
    );
};

exports.default = TraceTypeErrorBarsIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/TraceTypeErrorBarsIcon.js
// module id = 711
// module chunks = 0